import { forceUpdateMessages } from '@/components/force-update/force-update.messages';
import Loader from '@/components/ui/loader';
import { isTauri } from '@/tauri/utils';
import { isMSI } from '@/utils/appConfiguration';
import { Button } from '@heidi/design-system/button';
import { TypographyP2 } from '@heidi/design-system/typography';
import { CircleAlert } from 'lucide-react';
import { useIntl } from 'react-intl';

export type ForceUpdateBannerProps = {
  message: string;
  onUpdateNow: () => void;
  isInstalling?: boolean;
  actionText?: string;
};

const ForceUpdateBanner = ({
  message,
  isInstalling,
  actionText,
  onUpdateNow,
}: ForceUpdateBannerProps) => {
  const intl = useIntl();
  if (!isTauri()) return null;

  return (
    // `pointer-events-auto` re-enables clicks when an open Radix Dialog
    // (e.g. <SignInModal /> on the login page) has set `pointer-events: none`
    // on <body>. Without this the banner is visible but the Install button
    // is unclickable until the modal closes.
    <div className="pointer-events-auto relative z-[99999] flex w-full items-center justify-between gap-3 border border-validation-warning-border bg-validation-warning-muted px-4 py-1.5">
      <div className="flex items-center gap-2">
        <CircleAlert size={18} className="text-validation-warning" />
        <TypographyP2 className="text-validation-warning">{message}</TypographyP2>
      </div>
      {!isMSI() && (
        <Button variant="default" size="sm" onClick={onUpdateNow} disabled={isInstalling}>
          {isInstalling && <Loader className="text-current" />}
          {actionText || intl.formatMessage(forceUpdateMessages.installAndRelaunch)}
        </Button>
      )}
    </div>
  );
};

export default ForceUpdateBanner;
